import React, { useEffect, useRef } from 'react';
import { renderAsync } from 'docx-preview';

const DocumentViewer = ({ selectedDocument }) => {
    const viewerRef = useRef(null);

    useEffect(() => {
        const renderDocument = async () => {
            if (selectedDocument?.blob && viewerRef.current) {
                viewerRef.current.innerHTML = ''; // Clear previous content
                try {
                    await renderAsync(selectedDocument.blob, viewerRef.current);
                } catch (error) {
                    console.error("Error rendering document:", error);
                }
            }
        };

        if (selectedDocument?.blob.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
            renderDocument();
        }
    }, [selectedDocument]);

    if (!selectedDocument) return null;

    const { blob, url, name } = selectedDocument;

    switch (blob.type) {
        case 'application/pdf':
            return <iframe src={url} title={name} style={{ width: "100%", height: "calc(100vh - 50px)" }} />;
        case 'image/png':
        case 'image/jpeg':
            return <img src={url} alt={name} width="100%" />;
        case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
            return (
                <div>
                    <h3 style={{ marginBottom: '50px' }}>{name}</h3>
                    <div ref={viewerRef} style={{padding: "20px 5%"}}></div>
                </div>
            );
        default:
            return <p>Unsupported file type</p>;
    }
};

export default DocumentViewer;